package com.islamicmedia.site.pages.isitsafe

import androidx.compose.runtime.Composable
import com.islamicmedia.site.components.PublicReviewPage
import com.varabyte.kobweb.core.Page

/** Public SEO review — "/isitsafe/despicable-me-4". Pulls the REAL cached analysis (baked in StaticReviews). */
@Page("/isitsafe/despicable-me-4")
@Composable
fun DespicableMe4ReviewPage() {
    PublicReviewPage(
        slug = "despicable-me-4",
        blurb = "Is Despicable Me 4 OK for Muslim kids? Fitrah Filter checks movies, shows, games, and books against Islamic values. Here's the full breakdown for parents.",
    )
}
